import { render } from "./widget-eofider-ge.vue?vue&type=template&id=9222edca"
import script from "./widget-eofider-ge.vue?vue&type=script&setup=true&lang=js"
export * from "./widget-eofider-ge.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/e-grid/eosrc-card/widgets/widget-eofider-ge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9222edca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9222edca', __exports__)) {
    api.reload('9222edca', __exports__)
  }
  
  module.hot.accept("./widget-eofider-ge.vue?vue&type=template&id=9222edca", () => {
    api.rerender('9222edca', render)
  })

}


export default __exports__